import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import ShowMore from 'reactGarden/ShowMore'
import ContentThumb from 'reactGarden/ContentsThumb'

import WishlistProviderMethods from 'reactSite/Wishlist/provider'
import { Widget } from 'reactSite/Modular/components/Widget'

import * as S from './styled'

const ContentList = ({ fullList = false, ...props }) => {
  const [contents, setContents] = useState([])

  const getLastContents = () => {
    const contents = JSON.parse(props.contents)

    setContents(contents)
  }

  useEffect(getLastContents, [])

  const renderContent = () => {
    const isFullList = (fullList === 'true')

    const contentComponents = (contents.map(item => <ContentThumb item={ item } key={ item.id } />))

    if (isFullList) {
      return (<S.Wrapper>{ contentComponents }</S.Wrapper>)
    }

    return (
      <ShowMore
        className="contents-list-thumbnails"
        visibleRows={1}
        scrollToParent={true}>
        { contentComponents }
      </ShowMore>
    )
  }

  return (
    <Widget title={ props.title }>
      <WishlistProviderMethods items={ contents }>
        { renderContent() }
      </WishlistProviderMethods>
    </Widget>
  )
}

ContentList.propTypes = {
  title: PropTypes.string
}

export default ContentList
